module.exports = __webpack_public_path__ + "img/P609205802.fcff34c2.jpg";